
export default (store, to, from, next) => {
  const demoViews = ['h', 'typeMenu', 'clientType', 'actions', 'options', 'creditLine'];

  if (store.state.app.demo === true) {
    next();
  }
  if (store.state.app.demo === false && demoViews.indexOf(to.name) > -1) {
    store.dispatch('setFlowType', 'wifi');
    next('setNumber');
  }
  if (store.state.app.demo === false && demoViews.indexOf(to.name) === -1) {
    next();
  }
};



// WEBPACK FOOTER //
// ./src/middlewares/NotEnterDemoViews.js